export function CatAnimation() {
  return (
    <div className="cat-animation">
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1000 1000"
        preserveAspectRatio="xMidYMid meet"
        width="100%"
        height="100%"
      >
        <circle
          id="Background"
          cx="500"
          cy="500"
          r="222.6"
          className="fillColD"
        />
        <g id="Direction">
          <path
            id="StarD"
            className="fillColA"
            d="M772.2,400.1c11.5-25,10.8-27.8-11.7-43.7c25,11.5,27.8,10.8,43.7-11.7c-11.5,25-10.8,27.8,11.7,43.7 C790.8,376.9,788,377.7,772.2,400.1z"
          />
          <path
            id="StarC"
            className="fillColA"
            d="M645.6,169.7c11.5-25,10.8-27.8-11.7-43.7c25,11.5,27.8,10.8,43.7-11.7c-11.5,25-10.8,27.8,11.7,43.7 C664.3,146.5,661.5,147.2,645.6,169.7z"
          />
          <path
            id="StarB"
            className="fillColA"
            d="M320.4,312c11.5-25,10.8-27.8-11.7-43.7c25,11.5,27.8,10.8,43.7-11.7c-11.5,25-10.8,27.8,11.7,43.7 C339.1,288.8,336.3,289.5,320.4,312z"
          />
          <path
            id="StarA"
            className="fillColA"
            d="M193.4,367.5c11.5-25,10.8-27.8-11.7-43.7c25,11.5,27.8,10.8,43.7-11.7c-11.5,25-10.8,27.8,11.7,43.7 C212.1,344.3,209.3,345,193.4,367.5z"
          />
          <g id="Vuelo">
            <g id="Roket">
              <polyline
                className="fillNone stk10 stkColC"
                points="559.3,618.2 630.6,663.6 630.6,587.2 586.5,466 	"
              />
              <polyline
                className="fillNone stk10 stkColC"
                points="441.6,443.6 367.8,546.6 367.8,623 451.6,601.5 	"
              />
              <polygon
                className="fillColB"
                points="586.5,466 559.3,618.2 630.6,663.6 630.6,587.2 	"
              />
              <polyline
                className="fillNone stk4 stkColC"
                points="559.3,618.2 630.6,663.6 630.6,587.2 586.5,466 	"
              />
              <path
                className="fillNone stk10 stkColC"
                d="M597.4,308c0-43-34.9-148.1-77.9-148.1S441.6,265,441.6,308v271.5c0,11.5,7.6,23,22.8,31.8 s35.2,13.2,55.1,13.2s39.9-4.4,55.1-13.2c15.2-8.8,22.8-20.3,22.8-31.8L597.4,308z"
              />
              <polygon
                className="fillColB"
                points="367.8,546.6 367.8,623 441.6,580 441.6,443.6 	"
              />
              <path
                className="fillColC"
                d="M441.6,580l-73.8,43l83.8-21.4C445.1,594.9,441.8,587.5,441.6,580z"
              />
              <polyline
                className="fillNone stk4 stkColC"
                points="441.6,443.6 367.8,546.6 367.8,623 451.6,601.5 	"
              />
              <path
                className="fillColB"
                d="M519.5,160c-43,0-77.9,105-77.9,148.1c0-11.5,7.6-23,22.8-31.8c15.2-8.8,35.2-13.2,55.1-13.2 c19.9,0,39.9,4.4,55.1,13.2c15.2,8.8,22.8,20.3,22.8,31.8C597.4,265,562.5,160,519.5,160z"
              />
              <path
                className="fillColA"
                d="M569.9,273.8c-14.5-7.1-32.5-10.7-50.4-10.7c0,0,0,0,0,0l0-103.1C542.8,160,562.6,225.1,569.9,273.8z"
              />
              <path
                className="fillColC"
                d="M586.5,602.5c-3.3,3.2-7.2,6.1-11.9,8.9c-4.7,2.7-9.9,5-15.3,6.9l71.3,45.4L586.5,602.5z"
              />
              <path
                className="fillNone stk10 stkColC"
                d="M548.8,664.6l-19.3-57.8c-0.9-2.7-3.1-5.2-6.7-7.2c-4.7-2.7-11-4.1-17.2-4.1s-12.4,1.4-17.2,4.1 c-3.6,2.1-5.8,4.6-6.7,7.2l-19.3,57.8c-0.5,1.6-0.8,3.2-0.8,4.9c0,6.5,4.3,13,12.9,18c8.6,5,19.9,7.4,31.1,7.4 c11.3,0,22.5-2.5,31.1-7.4c8.6-5,12.9-11.5,12.9-18C549.6,667.8,549.4,666.2,548.8,664.6z"
              />
              <path
                className="fillNone stk10 stkColC"
                d="M614.5,626.7l-19.3-57.8c-0.9-2.7-3.1-5.2-6.7-7.2c-4.7-2.7-11-4.1-17.2-4.1s-12.4,1.4-17.2,4.1 c-3.6,2.1-5.8,4.6-6.7,7.2l-19.3,57.8c-0.5,1.6-0.8,3.2-0.8,4.9c0,6.5,4.3,13,12.9,18c8.6,5,19.9,7.4,31.1,7.4 c11.3,0,22.5-2.5,31.1-7.4c8.6-5,12.9-11.5,12.9-18C615.3,629.9,615,628.3,614.5,626.7z"
              />
              <path
                className="fillNone stk10 stkColC"
                d="M524.8,612.8l-19.3-57.8c-0.9-2.7-3.1-5.2-6.7-7.2c-4.7-2.7-11-4.1-17.2-4.1s-12.4,1.4-17.2,4.1 c-3.6,2.1-5.8,4.6-6.7,7.2l-19.3,57.8c-0.5,1.6-0.8,3.2-0.8,4.9c0,6.5,4.3,13,12.9,18c8.6,5,19.9,7.4,31.1,7.4 c11.3,0,22.5-2.5,31.1-7.4c8.6-5,12.9-11.5,12.9-18C525.6,616,525.3,614.4,524.8,612.8z"
              />
              <path
                className="fillWhite"
                d="M574.6,276.2c-15.2-8.8-35.2-13.2-55.1-13.2c-19.9,0-39.9,4.4-55.1,13.2c-15.2,8.8-22.8,20.3-22.8,31.8 l0,271.5c0-11.5,7.6-23,22.8-31.8c15.2-8.8,35.2-13.2,55.1-13.2c19.9,0,39.9,4.4,55.1,13.2c15.2,8.8,22.8,20.3,22.8,31.8V308 C597.4,296.5,589.8,285,574.6,276.2z"
              />
              <path
                className="fillColA"
                d="M557.7,403.9c-11.5-3.8-24.4-5.7-37.3-5.8l39.8,37.4L557.7,403.9z"
              />
              <path
                className="fillColC"
                d="M557.7,540.3c-11.5-3.8-24.4-5.7-37.3-5.8l39.8-22.6L557.7,540.3z"
              />
              <polygon
                className="fillColB"
                points="520.4,398.1 520.4,534.5 560.1,511.9 560.1,435.5 	"
              />
              <path
                className="fillColC"
                d="M464.4,611.3c-15.2-8.8-22.8-20.3-22.8-31.8c0-11.5,7.6-23,22.8-31.8c15.2-8.8,35.2-13.2,55.1-13.2 s39.9,4.4,55.1,13.2c15.2,8.8,22.8,20.3,22.8,31.8c0,11.5-7.6,23-22.8,31.8c-15.2,8.8-35.2,13.2-55.1,13.2S479.6,620.1,464.4,611.3 z"
              />
              <g className="fillNone stk4 stkColC">
                <path d="M441.6,579.5c0-11.5,7.6-23,22.8-31.8c15.2-8.8,35.2-13.2,55.1-13.2s39.9,4.4,55.1,13.2 c15.2,8.8,22.8,20.3,22.8,31.8" />
                <path d="M441.6,308c0-11.5,7.6-23,22.8-31.8c15.2-8.8,35.2-13.2,55.1-13.2s39.9,4.4,55.1,13.2 c15.2,8.8,22.8,20.3,22.8,31.8" />
                <path d="M524.8,612.8l-19.3-57.8c-0.9-2.7-3.1-5.2-6.7-7.2c-4.7-2.7-11-4.1-17.2-4.1s-12.4,1.4-17.2,4.1 c-3.6,2.1-5.8,4.6-6.7,7.2l-19.3,57.8c-0.5,1.6-0.8,3.2-0.8,4.9c0,6.5,4.3,13,12.9,18c8.6,5,19.9,7.4,31.1,7.4 c11.3,0,22.5-2.5,31.1-7.4c8.6-5,12.9-11.5,12.9-18C525.6,616,525.3,614.4,524.8,612.8z" />
                <path d="M614.5,626.7l-19.3-57.8c-0.9-2.7-3.1-5.2-6.7-7.2c-4.7-2.7-11-4.1-17.2-4.1s-12.4,1.4-17.2,4.1 c-3.6,2.1-5.8,4.6-6.7,7.2l-19.3,57.8c-0.5,1.6-0.8,3.2-0.8,4.9c0,6.5,4.3,13,12.9,18c8.6,5,19.9,7.4,31.1,7.4 c11.3,0,22.5-2.5,31.1-7.4c8.6-5,12.9-11.5,12.9-18C615.3,629.9,615,628.3,614.5,626.7z" />
                <path d="M557.7,403.9c-11.5-3.8-24.4-5.7-37.3-5.8v136.4c12.9,0.1,25.7,2,37.3,5.8l2.5-28.4v-76.4L557.7,403.9z" />
                <path d="M597.4,308c0-43-34.9-148.1-77.9-148.1S441.6,265,441.6,308v271.5c0,11.5,7.6,23,22.8,31.8 s35.2,13.2,55.1,13.2s39.9-4.4,55.1-13.2c15.2-8.8,22.8-20.3,22.8-31.8L597.4,308z" />
              </g>
              <circle
                cx="419.8"
                cy="352.2"
                r="93.4"
                className="fillWhite"
                opacity="0.7"
              />
            </g>
            <g id="Motor">
              <g id="Tobera">
                <path
                  className="stkColC stk4 fillColA"
                  d="M548.8,664.6l-19.3-57.8c-0.9-2.7-3.1-5.2-6.7-7.2c-4.7-2.7-11-4.1-17.2-4.1s-12.4,1.4-17.2,4.1 c-3.6,2.1-5.8,4.6-6.7,7.2l-19.3,57.8c-0.5,1.6-0.8,3.2-0.8,4.9c0,6.5,4.3,13,12.9,18c8.6,5,19.9,7.4,31.1,7.4 c11.3,0,22.5-2.5,31.1-7.4c8.6-5,12.9-11.5,12.9-18C549.6,667.8,549.4,666.2,548.8,664.6z"
                />
                <path
                  className="fillColC"
                  d="M474.5,687.4c-8.6-5-12.9-11.5-12.9-18c0-6.5,4.3-13,12.9-18s19.9-7.4,31.1-7.4c11.3,0,22.5,2.5,31.1,7.4 s12.9,11.5,12.9,18c0,6.5-4.3,13-12.9,18s-19.9,7.4-31.1,7.4C494.4,694.8,483.1,692.3,474.5,687.4z"
                />
              </g>
              <g id="Flama">
                <path
                  id="FlamaB"
                  opacity="0.7"
                  className="fillColA"
                  d="M545.9,739.8c0,46.6-18,149-40.3,149s-40.3-102.4-40.3-149c0-46.6,7.3-84.4,40.3-84.4S545.9,693.2,545.9,739.8 z"
                />
                <path
                  id="FlamaA"
                  className="fillWhite"
                  d="M525.3,710.7c0,22.8-8.8,72.8-19.7,72.8s-19.7-50-19.7-72.8c0-22.8,3.6-41.3,19.7-41.3 C521.7,669.4,525.3,687.9,525.3,710.7z"
                />
              </g>
            </g>
            <use xlinkHref="#Motor" transform="translate(-24.0262 -51.7737)" />
            <use xlinkHref="#Motor" transform="translate(65.6408 -37.901)" />
            <g id="Cabina">
              <path
                className="fillColB"
                d="M460,445.1c0.4-5.2,0.7-10.4,0.7-15.6c0-16-1.5-32-1.8-48c0.1-34.9,9.2-48,22.9-56.9 c12.1-5.8,23.6-6.2,33.7-3c-13.1-11.6-31.3-16.5-51-7c-13.7,8.9-22.8,21.9-22.9,56.9c0.2,16,1.7,32,1.8,48 c0,9.9-1.2,19.7-1.5,29.6c0.1,2.8,0.6,3.2,0.9,3.4c0.3,0.2,0.8,0.2,1.6,0C447.1,451.9,452.8,449,460,445.1z"
              />
              <path
                className="fillNone stk4 stkColC"
                d="M442.7,452.5c-0.4-0.3-0.9-0.6-0.9-3.4c0.3-9.9,1.6-19.7,1.5-29.6c0-16-1.5-32-1.8-48 c0.1-34.9,9.2-48,22.9-56.9c21.9-10.5,41.9-3.3,55.2,11.1"
              />
              <path
                className="fillColC"
                d="M515.6,321.7c-10.1-3.2-21.6-2.8-33.7,3c-13.7,8.9-22.8,21.9-22.9,56.9c0.2,16,1.7,32,1.8,48 c0,5.2-0.3,10.4-0.7,15.6c10-5.5,22.7-13.2,33.6-20.4c18.3-18.6,29.6-44.2,29.6-72.4c0-9.2-1.2-18-3.4-26.5 C518.4,324.3,517,322.9,515.6,321.7z"
              />
              <path
                className="stkColC stk6 fillColA"
                d="M481.5,432.2c-18.4-10.6-24.7-34.1-14.1-52.5s34.1-24.7,52.5-14.1"
              />
              <path
                className="fillWhite"
                d="M419.8,248.9c-57.1,0-103.4,46.3-103.4,103.4s46.3,103.4,103.4,103.4s103.4-46.3,103.4-103.4 S476.9,248.9,419.8,248.9z M419.8,445.6c-51.5,0-93.4-41.9-93.4-93.4c0-51.5,41.9-93.4,93.4-93.4c51.5,0,93.4,41.9,93.4,93.4 C513.1,403.7,471.3,445.6,419.8,445.6z"
              />
              <circle
                className="stkColB stk6 fillNone"
                cx="419.8"
                cy="352.2"
                r="103.4"
              />
            </g>
            <g id="Michi">
              <path
                className="fillColA"
                d="M374.3,285.4c-4.2,7.3,4.1,26.4,9.2,36.5c-1.5,2.2-3,4.4-4.4,6.8c-1.4,2.4-2.6,4.8-3.7,7.2 c-11.3,0.7-32,3-36.2,10.3c-5.9,10.2,13.9,52.6,56.7,77.3c29.6,17.1,70.2,2.4,90.5-32.9c20.4-35.3,12.9-77.7-16.8-94.8 C426.8,271.1,380.2,275.2,374.3,285.4z"
              />
              <path
                className="stkColC stk6 fillNone"
                d="M374.3,285.4c-4.2,7.3,4.1,26.4,9.2,36.5c-1.5,2.2-3,4.4-4.4,6.8c-1.4,2.4-2.6,4.8-3.7,7.2 c-11.3,0.7-32,3-36.2,10.3c-5.9,10.2,13.9,52.6,56.7,77.3c29.6,17.1,70.2,2.4,90.5-32.9c20.4-35.3,12.9-77.7-16.8-94.8 C426.8,271.1,380.2,275.2,374.3,285.4z"
              />
              <path
                className="stkColC stk4 fillNone"
                d="M373.9,407.9l-9.2,12.3 M367,401.3l-12.2,12.1 M346.3,402.3l13.7-8.8 M445.1,284.6l6-14.1 M435.9,281.9 l4.4-16.6 M425.6,279.8l0.8-16.2"
              />
              <path
                className="fillColC"
                d="M459,327l8.1,8.8l-11.7-2.6c-1.1,5,1,10.3,5.7,13c5.7,3.3,13,1.3,16.3-4.4s1.3-13-4.4-16.3 C468.4,322.7,462.7,323.5,459,327z"
              />
              <path
                className="fillColC"
                d="M421.1,392.6l8.1,8.8l-11.7-2.6c-1.1,5,1,10.3,5.7,13c5.7,3.3,13,1.3,16.3-4.4s1.3-13-4.4-16.3 C430.5,388.3,424.8,389.1,421.1,392.6z"
              />
              <path
                className="fillColC"
                d="M464.6,374.3l-2.5-7.4c-0.5-1.5-2.6-1.7-3.4-0.3l-7,12.1c-0.8,1.4,0.4,3.1,2,2.8l7.7-1.5 C463.9,379.4,465.4,376.8,464.6,374.3z"
              />
            </g>
            <path
              id="Luz"
              opacity="0.7"
              className="fillNone stk12 stkWhite"
              d="M372.8,305.2c26-26,68.2-26,94.2,0"
            />
          </g>
        </g>
      </svg>
    </div>
  );
}
